import React, {useEffect, useRef, useState} from 'react';
import Konva from 'konva';
import {Stage, Layer, Image, Transformer} from 'react-konva';
import RepIcon from "../../data/icons/중계기/_THM_Normal.png";
import SensorFireIcon from "../../data/icons/화재/_THM_Normal.png";
import SensorMotionIcon from "../../data/icons/움직임/_THM_Normal.png";
import SensorBellIcon from "../../data/icons/비상벨/_THM_Normal.png";
import RepIconMint from "../../data/icons/중계기/_THM_Mint.png";
import SensorFireIconMint from "../../data/icons/화재/_THM_Mint.png";
import SensorMotionIconMint from "../../data/icons/움직임/_THM_Mint.png";
import SensorBellIconMint from "../../data/icons/비상벨/_THM_Mint.png";
import RepIconCrit from "../../data/icons/중계기/_THM_Critical.png";
import SensorFireIconCrit from "../../data/icons/화재/_THM_Critical.png";
import SensorMotionIconCrit from "../../data/icons/움직임/_THM_Critical.png";
import SensorBellIconCrit from "../../data/icons/비상벨/_THM_Critical.png";
import RepIconMajor from "../../data/icons/중계기/_THM_Major.png";
import SensorFireIconMajor from "../../data/icons/화재/_THM_Major.png";
import SensorMotionIconMajor from "../../data/icons/움직임/_THM_Major.png";
import SensorBellIconMajor from "../../data/icons/비상벨/_THM_Major.png";
import RepIconMinor from "../../data/icons/중계기/_THM_Minor.png";
import SensorFireIconMinor from "../../data/icons/화재/_THM_Minor.png";
import SensorMotionIconMinor from "../../data/icons/움직임/_THM_Minor.png";
import SensorBellIconMinor from "../../data/icons/비상벨/_THM_Minor.png";
import SensorFireIconFire from "../../data/icons/fire/_THM_fire.png";
import SensorMotionIconFire from "../../data/icons/fire/_THM_motion.png";
import SensorBellIconFire from "../../data/icons/fire/_THM_bell.png";


const URLImage = ({
                      src = '',
                      propWidth,
                      propHeight,
                      setInfo,
                      refStage
                  }) => {

    useEffect(() => {
        console.log('load image')
        loadImage();
    }, [src]);

    const [stImage, setImage] = useState(null);
    const [stImageCtl, setImageCtl] = useState(null);

    const refImage = useRef();

    let image;

    const loadImage = () => {
        if (src != null) {
            image = new window.Image();
            image.src = src;
            image.addEventListener('load', handleLoad);
        }
    };


    const handleLoad = () => {
        // after setState react-konva will update canvas and redraw the layer
        // because "image" property is changed
        let ki = new Konva.Image({
            image: image
        });

        setImage(ki.image());
        setImageCtl(ki);
        // if you keep same image object during source updates
        // you will have to update layer manually:
        // this.imageNode.getLayer().batchDraw();
        let cw = refImage.current.width();
        let ch = refImage.current.height();
        let fit_info = getScaledImageCoordinates(
            propWidth, propHeight,
            cw, ch);
        // refImage.current.scaleX(fit_info.ratio);
        // refImage.current.scaleY(fit_info.ratio);
        // refImage.current.setAttrs({
        //   x: fit_info.posLeft,
        //   y: fit_info.posTop
        // });
        setInfo(fit_info);

        let stage = refStage.current
        stage.scale({x: fit_info.ratio, y: fit_info.ratio});

        var newPos = {
            x: fit_info.posLeft,
            y: fit_info.posTop,
        };
        stage.position(newPos);
    };

    // const onClick = () => {
    //     let cw = refImage.current.width();
    //     let ch = refImage.current.height();
    //     let fit_info = getScaledImageCoordinates(
    //         propWidth, propHeight,
    //         cw, ch);
    // };


    const getScaledImageCoordinates = (
        containerWidth,
        containerHeight,
        width,
        height,
    ) => {
        let widthRatio = (containerWidth) / width;
        let heightRatio = (containerHeight) / height;
        let bestRatio = Math.min(widthRatio, heightRatio);
        let newWidth = width * bestRatio;
        let newHeight = height * bestRatio;
        let posLeft = (containerWidth - newWidth) / 2;
        let posTop = (containerHeight - newHeight) / 2;

        return {
            width: newWidth,
            height: newHeight,
            ratio: bestRatio,
            posLeft: posLeft,
            posTop: posTop
        }
    };

    return (
        <>
            <Image
                // onClick={onClick}
                ref={refImage}
                image={stImage}
            />
            {/*<Transformer></Transformer>*/}
        </>
    );
};

const AxcCanvas = ({
                       propImageSrc = "",
                       propWidthRef,
                       propWidthMargin = 0,
                       propHeight = 650,
                       propMarkerList = [],
                       setMarkerList = null,
                       onClickMarker = null,
                       draggable = true,
                       refStage,
                   }) => {
    const [stInfo, setInfo] = useState({});
    const [stWidth, setWidth] = useState(800);
    // const refStage = useRef();

    useEffect(() => {
        console.log('image change')
    }, [propImageSrc])

    const handleResize = () => {
        //console.log(`resize`);
        setWidth(propWidthRef.current ? propWidthRef.current.offsetWidth - propWidthMargin : 0);
    }

    useEffect(() => {
        setWidth(propWidthRef.current ? propWidthRef.current.offsetWidth - propWidthMargin : 0);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])

    const handleDragStart = (e) => {
    };

    const handleDragEnd = (e) => {
        console.log(stInfo);
        let realX = (e.evt.layerX - stInfo.posLeft) / stInfo.ratio - offsetIcon * 0.15 / stInfo.ratio;
        let realY = (e.evt.layerY - stInfo.posTop) / stInfo.ratio - offsetIcon * 0.15 / stInfo.ratio;
        // let realX = (e.evt.layerX - offsetIcon) / stInfo.ratio;
        // let realY = (e.evt.layerY - offsetIcon) / stInfo.ratio;


        if (setMarkerList != null) {
            setMarkerList(
                propMarkerList.map((mark) => {
                    if (mark.id === e.target.id()) {
                        return {
                            ...mark,
                            x: realX,
                            y: realY,
                            selected: true,
                            status: 'Mint',
                            isModified: true
                        }
                    } else {
                        return {
                            ...mark,
                            selected: false,
                            status: 'Normal',
                        }
                    }
                })
            );
        }
    };


    const offsetIcon = 50;
    const refRepIcon = useRef();
    const refRepIconMint = useRef();
    const refRepIconCrit = useRef();
    const refRepIconMajor = useRef();
    const refRepIconMinor = useRef();

    const refSensorFireIcon = useRef();
    const refSensorFireIconMint = useRef();
    const refSensorFireIconCrit = useRef();
    const refSensorFireIconMajor = useRef();
    const refSensorFireIconMinor = useRef();
    const refSensorFireIconFire = useRef();

    const refSensorMotionIcon = useRef();
    const refSensorMotionIconMint = useRef();
    const refSensorMotionIconCrit = useRef();
    const refSensorMotionIconMajor = useRef();
    const refSensorMotionIconMinor = useRef();
    const refSensorMotionIconFire = useRef();

    const refSensorBellIcon = useRef();
    const refSensorBellIconMint = useRef();
    const refSensorBellIconCrit = useRef();
    const refSensorBellIconMajor = useRef();
    const refSensorBellIconMinor = useRef();
    const refSensorBellIconFire = useRef();

    const getImageIcon = (type, status) => {
        let ret;
        if (type === 'Rep') {
            if (status === 'Normal') {
                ret = refRepIcon.current;
            } else if (status === 'Mint') {
                ret = refRepIconMint.current;
            } else if (status === 'Crit') {
                ret = refRepIconCrit.current;
            } else if (status === 'Major') {
                ret = refRepIconMajor.current;
            } else {
                ret = refRepIconMinor.current;
            }
        } else if (type === 'Fire') {
            if (status === 'Normal') {
                ret = refSensorFireIcon.current;
            } else if (status === 'Mint') {
                ret = refSensorFireIconMint.current;
            } else if (status === 'Crit') {
                ret = refSensorFireIconCrit.current;
            } else if (status === 'Major') {
                ret = refSensorFireIconMajor.current;
            } else if (status === 'Minor') {
                ret = refSensorFireIconMinor.current;
            } else {
                ret = refSensorFireIconFire.current;
            }
        } else if (type === 'Motion') {
            if (status === 'Normal') {
                ret = refSensorMotionIcon.current;
            } else if (status === 'Mint') {
                ret = refSensorMotionIconMint.current;
            } else if (status === 'Crit') {
                ret = refSensorMotionIconCrit.current;
            } else if (status === 'Major') {
                ret = refSensorMotionIconMajor.current;
            } else if (status === 'Minor') {
                ret = refSensorMotionIconMinor.current;
            } else {
                ret = refSensorMotionIconFire.current;
            }
        } else if (type === 'Bell') {
            if (status === 'Normal') {
                ret = refSensorBellIcon.current;
            } else if (status === 'Mint') {
                ret = refSensorBellIconMint.current;
            } else if (status === 'Crit') {
                ret = refSensorBellIconCrit.current;
            } else if (status === 'Major') {
                ret = refSensorBellIconMajor.current;
            } else if (status === 'Minor') {
                ret = refSensorBellIconMinor.current;
            } else {
                ret = refSensorBellIconFire.current;
            }
        }
        return ret;
    }

    const onWheelStage = (e) => {

        // stop default scrolling
        e.evt.preventDefault();

        const scaleBy = 1.1
        let stage = refStage.current
        // console.log(e.target);

        var oldScale = stage.scaleX();
        var pointer = stage.getPointerPosition();

        var mousePointTo = {
            x: (pointer.x - stage.x()) / oldScale,
            y: (pointer.y - stage.y()) / oldScale,
        };

        // how to scale? Zoom in? Or zoom out?
        let direction = e.evt.deltaY > 0 ? -1 : 1;

        var newScale = direction > 0 ? oldScale * scaleBy : oldScale / scaleBy;

        stage.scale({x: newScale, y: newScale});

        var newPos = {
            x: pointer.x - mousePointTo.x * newScale,
            y: pointer.y - mousePointTo.y * newScale,
        };
        stage.position(newPos);

        setInfo(prevState => {
            return {
                ...prevState,
                ratio: newScale,
                posLeft: newPos.x,
                posTop: newPos.y,
            }
        });
    }

    const onDragEndStage = (e) => {
        let stage = refStage.current
        setInfo(prevState => {
            return {
                ...prevState,
                posLeft: stage.x(),
                posTop: stage.y(),
            }
        });
    }

    return (
        <>
            <img src={RepIcon} ref={refRepIcon} hidden alt={RepIcon}/>
            <img src={RepIconMint} ref={refRepIconMint} hidden alt={RepIconMint}/>
            <img src={RepIconCrit} ref={refRepIconCrit} hidden alt={RepIconCrit}/>
            <img src={RepIconMajor} ref={refRepIconMajor} hidden alt={RepIconMajor}/>
            <img src={RepIconMinor} ref={refRepIconMinor} hidden alt={RepIconMinor}/>

            <img src={SensorFireIcon} ref={refSensorFireIcon} hidden alt={SensorFireIcon}/>
            <img src={SensorFireIconMint} ref={refSensorFireIconMint} hidden alt={SensorFireIconMint}/>
            <img src={SensorFireIconCrit} ref={refSensorFireIconCrit} hidden alt={SensorFireIconCrit}/>
            <img src={SensorFireIconMajor} ref={refSensorFireIconMajor} hidden alt={SensorFireIconMajor}/>
            <img src={SensorFireIconMinor} ref={refSensorFireIconMinor} hidden alt={SensorFireIconMinor}/>
            <img src={SensorFireIconFire} ref={refSensorFireIconFire} hidden alt={SensorFireIconFire}/>

            <img src={SensorMotionIcon} ref={refSensorMotionIcon} hidden alt={SensorMotionIcon}/>
            <img src={SensorMotionIconMint} ref={refSensorMotionIconMint} hidden alt={SensorMotionIconMint}/>
            <img src={SensorMotionIconCrit} ref={refSensorMotionIconCrit} hidden alt={SensorMotionIconCrit}/>
            <img src={SensorMotionIconMajor} ref={refSensorMotionIconMajor} hidden alt={SensorMotionIconMajor}/>
            <img src={SensorMotionIconMinor} ref={refSensorMotionIconMinor} hidden alt={SensorMotionIconMinor}/>
            <img src={SensorMotionIconFire} ref={refSensorMotionIconFire} hidden alt={SensorMotionIconFire}/>

            <img src={SensorBellIcon} ref={refSensorBellIcon} hidden alt={SensorBellIcon}/>
            <img src={SensorBellIconMint} ref={refSensorBellIconMint} hidden alt={SensorBellIconMint}/>
            <img src={SensorBellIconCrit} ref={refSensorBellIconCrit} hidden alt={SensorBellIconCrit}/>
            <img src={SensorBellIconMajor} ref={refSensorBellIconMajor} hidden alt={SensorBellIconMajor}/>
            <img src={SensorBellIconMinor} ref={refSensorBellIconMinor} hidden alt={SensorBellIconMinor}/>
            <img src={SensorBellIconFire} ref={refSensorBellIconFire} hidden alt={SensorBellIconFire}/>

            <Stage width={stWidth} height={propHeight} draggable={true}
                   onDragEnd={onDragEndStage} onWheel={onWheelStage} ref={refStage}>
                <Layer>
                    <URLImage
                        src={propImageSrc}
                        propWidth={stWidth}
                        propHeight={propHeight}
                        setInfo={setInfo}
                        refStage={refStage}
                    />
                    {propMarkerList.map((mark) => (
                        (mark.setup_yn === 'Y') ?
                            <Image
                                image={getImageIcon(mark.type, mark.status)}
                                id={mark.id}
                                key={mark.id}
                                // x={(mark.x - offsetIcon) * stInfo.ratio + stInfo.posLeft}
                                // y={(mark.y - offsetIcon) * stInfo.ratio + stInfo.posTop}
                                x={(mark.x - offsetIcon * 0.15 / stInfo.ratio)}
                                y={(mark.y - offsetIcon * 0.15 / stInfo.ratio)}
                                scaleX={0.3 / stInfo.ratio}
                                scaleY={0.3 / stInfo.ratio}
                                // scaleX={mark.isDragging ? 1.2 * stInfo.ratio : 0.8}
                                // scaleY={mark.isDragging ? 1.2 * stInfo.ratio : 0.8}
                                draggable={draggable ? true : false}
                                onDragStart={handleDragStart}
                                onDragEnd={handleDragEnd}
                                onClick={onClickMarker}
                            /> : ''
                    ))}
                </Layer>
            </Stage>
        </>
    );
};

export default AxcCanvas;